import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@app/shared';
import {RouterModule, Routes} from '@angular/router';

import {VatTuComponent, VatTuPopupRoute, vatTuRoute} from './';
import {
  VatTuDialogComponent,
  VatTuPopupComponent,
} from '@entities/vat-tu/vat-tu-dialog/vat-tu-dialog.component';
import {
  VatTuMgmtDeleteDialogComponent,
  VatTuMgmtDeletePopupComponent,
} from '@entities/vat-tu/vat-tu-delete-dialog/vat-tu-delete-dialog.component';
import {
  VatTuImportComponent,
  VatTuImportPopupComponent,
} from '@entities/vat-tu/vat-tu-import/vat-tu-import.component';
import {VatTuDetailComponent} from '@entities/vat-tu/vat-tu-detail/vat-tu-detail.component';
import {
  WarehouseStorageDialogComponent,
  WarehouseStoragePopupComponent,
} from '@entities/vat-tu/warehouse-storage-dialog/warehouse-storage-dialog.component';
import {
  VatTuDeleteHistoryDialogComponent,
  VatTuDeleteHistoryPopupComponent,
} from '@entities/vat-tu/vat-tu-delete-history-dialog/vat-tu-delete-history-dialog.component';
import {VatTuBlockDetailsComponent} from '@entities/vat-tu/vat-tu-block-details/vat-tu-block-details.component';

const ENTITY_STATES = [...vatTuRoute, ...VatTuPopupRoute];

@NgModule({
  declarations: [
    VatTuComponent,
    VatTuDialogComponent,
    VatTuPopupComponent,
    VatTuMgmtDeleteDialogComponent,
    VatTuMgmtDeletePopupComponent,
    VatTuImportComponent,
    VatTuImportPopupComponent,
    VatTuDetailComponent,
    WarehouseStorageDialogComponent,
    WarehouseStoragePopupComponent,
    VatTuDeleteHistoryDialogComponent,
    VatTuDeleteHistoryPopupComponent,
    VatTuBlockDetailsComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(ENTITY_STATES as Routes),
  ],
  entryComponents: [
    VatTuDialogComponent,
    VatTuMgmtDeleteDialogComponent,
    VatTuMgmtDeletePopupComponent,
    VatTuImportComponent,
    VatTuImportPopupComponent,
    WarehouseStoragePopupComponent,
    WarehouseStorageDialogComponent,
    VatTuDeleteHistoryDialogComponent,
    VatTuDeleteHistoryPopupComponent,
  ],
  exports: [VatTuBlockDetailsComponent],
})
export class VatTuModule {}
